import { render, staticRenderFns } from "./ProjectSoilSampleFormGroup.vue?vue&type=template&id=4bb9b140"
import script from "./ProjectSoilSampleFormGroup.vue?vue&type=script&lang=js"
export * from "./ProjectSoilSampleFormGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports